
namespace RioERP.Shipping {

    @Serenity.Decorators.registerClass()
    export class ShippingRulesGrid extends Serenity.EntityGrid<ShippingRulesRow, any> {
        protected getColumnsKey() { return ShippingRulesColumns.columnsKey; }
        protected getDialogType() { return ShippingRulesDialog; }
        protected getIdProperty() { return ShippingRulesRow.idProperty; }
        protected getInsertPermission() { return ShippingRulesRow.insertPermission; }
        protected getLocalTextPrefix() { return ShippingRulesRow.localTextPrefix; }
        protected getService() { return ShippingRulesService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}